import React from 'react';
import { Form, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

//dropdown LUBRICANTES
const DetalleNivel1 = props => {
  return (
    <option>{props.elemento.descrLubricante}</option>
  )
  };
  
const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrLubricante" id="miLista1" value={idLista.descrLubricante?idLista.descrLubricante:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown LUBRICANTES

//dropdown METODOS
const DetalleM = props => {
  return (
    <option>{props.elemento.descrMetodo}</option>
  )
  };
  
const ListaM = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleM elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrMetodo" id="miLista2" value={permiteUpdate?argsDocum.descrMetodo:idLista.descrMetodo?idLista.descrMetodo:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown METODOS

//dropdown TAREAS
const DetalleT = props => {
  return (
    <option>{props.elemento.descrTarea}</option>
  )
  };

const ListaT = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleT elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrTarea" id="miLista3" value={permiteUpdate?argsDocum.descrTarea:idLista.descrTarea?idLista.descrTarea:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown TAREAS

//dropdown UNIDADES
const DetalleU = props => {
  return (
    <option>{props.elemento.descrUnidad}</option>
  )
  };
  
const ListaU = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleU elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrUnidad" id="miLista4" value={permiteUpdate?argsDocum.descrUnidad:idLista.descrUnidad?idLista.descrUnidad:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown UNIDADES

//dropdown FRECUENCIAS
const DetalleF = props => {
  return (
    <option>{props.elemento.descrFrecuencia}</option>
  )
  };
  
const ListaF = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleF elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrFrecuencia" id="miLista5" value={permiteUpdate?argsDocum.descrFrecuencia:idLista.descrFrecuencia?idLista.descrFrecuencia:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown FRECUENCIAS

const DetalleP = props => {
  return (
    <option dato1={props.elemento.nombreArchivo}>{props.elemento.codProcedimiento}</option>
  ) 
};

const ListaP = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  // console.log(list)
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleP elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="codProcedimiento" id="miLista6" value={permiteUpdate?argsDocum.codProcedimiento:idLista.codProcedimiento?idLista.codProcedimiento:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

class VerDatCar2 extends React.Component {
  state={
    argsDocum: {codPlanta: this.props.idLista.codPlanta?this.props.idLista.codPlanta:"",
                descrEmpresa: this.props.idLista.descrEmpresa,
                descrPlanta: this.props.idLista.descrPlanta,
                codSeccion: this.props.idLista.codSeccion?this.props.idLista.codSeccion:"",
                descrSeccion: this.props.idLista.descrSeccion,
                codEquipo: this.props.idLista.codEquipo?this.props.idLista.codEquipo:"",
                descrEquipo: this.props.idLista.descrEquipo,
                codComponente: this.props.idLista.codComponente?this.props.idLista.codComponente:"",
                descrComponente: this.props.idLista.descrComponente,
                codMecanismo: this.props.idLista.codMecanismo?this.props.idLista.codMecanismo:"",
                descrMecanismo: this.props.idLista.descrMecanismo,
                consecutivo: this.props.idLista.consecutivo?this.props.idLista.consecutivo:"",
                descrLubricante: this.props.idLista.descrLubricante,
                descrMetodo: this.props.idLista.descrMetodo?this.props.idLista.descrMetodo:"Seleccionar...",
                descrTarea: this.props.idLista.descrTarea?this.props.idLista.descrTarea:"Seleccionar...",
                puntosLub: this.props.idLista.puntosLub?this.props.idLista.puntosLub:0,
                cantidad: this.props.idLista.cantidad?this.props.idLista.cantidad:0,
                descrUnidad: this.props.idLista.descrUnidad?this.props.idLista.descrUnidad:"Seleccionar...",
                descrFrecuencia: this.props.idLista.descrFrecuencia?this.props.idLista.descrFrecuencia:"Seleccionar...",
                descrFrecuenciaPre: this.props.idLista.descrFrecuenciaPre?this.props.idLista.descrFrecuenciaPre:"",
                minutos: this.props.idLista.minutos?this.props.idLista.minutos:0,
                codProcedimiento: this.props.idLista.codProcedimiento?this.props.idLista.codProcedimiento:"Seleccionar...",
                fechaProx: this.props.idLista.fechaProx?this.props.idLista.fechaProx:"",
                _id: this.props.idLista.idPlanta},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name!=="codMecanismo"&&ev.target.name!=="descrMecanismo"
      &&ev.target.name!=="descrLubricante"&&
          ev.target.name!=="descrMetodo"&&ev.target.name!=="descrTarea"
          ){
        const argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.value 
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;

    let listMet = []
    if(this.props.list1){
      listMet = this.props.list1.filter(elemento => elemento.tipoLub===this.props.idLista.tipoLub)
    }
    let listTarea = []
    if(this.props.list2){
      listTarea = this.props.list2.filter(elemento => elemento.tipoLub===this.props.idLista.tipoLub)
    }
    let listUnd = []
    if(this.props.list3){
      listUnd = this.props.list3.filter(elemento => elemento.tipoUnidad===this.props.idLista.tipoLub)
    }
    let listFrec = []
    if(this.props.list4){
      listFrec = this.props.list4.filter(elemento => elemento.tipoFrecuencia===this.props.idLista.tipoFrecuencia)
    }
    // console.log(this.props.list6, this.props.idLista.codProcedimiento)
    let listProc = []
    if(this.props.list6){
      listProc = this.props.list6.filter(elemento => elemento.codProcedimiento>0)
    }
    let fechaProx = this.props.idLista.fechaProx?this.props.idLista.fechaProx.substr(0, 10):""

    // console.log(this.props.list)
    // console.log(this.props.idLista)
    // console.log(argsDocum)
  
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          {this.props.idLista.descrPlanta} - {this.props.idLista.descrSeccion} - {this.props.idLista.descrEquipo} - {this.props.idLista.descrComponente} - {this.props.idLista.descrMecanismo}
        </button>
        {/* <div style={this.props.styles.backGr_2}> */}
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "20%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código Mecanismo</label>
                    <Form.Input autoComplete="off" name="codMecanismo" id="codMecanismo" value={this.props.permiteUpdate?argsDocum.codMecanismo:this.props.idLista.codMecanismo} onChange={this.handleChange} placeholder='Código Mecanismo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codMecanismo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "40%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Mecanismo</label>
                    <Form.Input autoComplete="off" name="descrMecanismo" id="descrMecanismo" value={this.props.permiteUpdate?argsDocum.descrMecanismo:this.props.idLista.descrMecanismo} onChange={this.handleChange} placeholder='Descripción Mecanismo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrMecanismo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "40%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Lubricante</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
              </div>
            </div>
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "20%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Consecutivo</label>
                    <Form.Input autoComplete="off" name="consecutivo" id="consecutivo" value={this.props.permiteUpdate?argsDocum.consecutivo:this.props.idLista.consecutivo?this.props.idLista.consecutivo:""} onChange={this.handleChange} placeholder='Descripción Fabricante' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'consecutivo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "40%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Método</label>
                    <ListaM list={listMet} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "40%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tarea</label>
                    <ListaT list={listTarea} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
              </div>
            </div>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "20%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Puntos</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="puntosLub" id="puntosLub" placeholder='Puntos' value={this.props.permiteUpdate?argsDocum.puntosLub:this.props.idLista.puntosLub?this.props.idLista.puntosLub:0} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Cantidad</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="cantidad" id="cantidad" placeholder='Cantidad' value={this.props.permiteUpdate?argsDocum.cantidad:this.props.idLista.cantidad?this.props.idLista.cantidad:0} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Unidad</label>
                    <ListaU list={listUnd} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "40%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Frecuencia</label>
                    <ListaF list={listFrec} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
              </div>
            </div>
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "20%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Minutos</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="minutos" id="minutos" placeholder='minutos' value={this.props.permiteUpdate?argsDocum.minutos:this.props.idLista.minutos?this.props.idLista.minutos:0} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "40%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Procedimiento</label>
                    <ListaP list={this.props.list6} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "40%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Fecha prox</label>
                    <input style={this.props.styles.input} type='date' name="fechaProx" id="fechaProx" value={this.props.permiteUpdate?argsDocum.fechaProx:fechaProx} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
              </div>
            </div>

            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerDatCar2
